/**
 * Service-worker update prompt.
 *
 * The service worker is registered with `registerType: 'prompt'` rather than
 * auto-updating, deliberately: silently swapping the app out underneath an
 * operator who is mid-sale is worse than asking. This also surfaces
 * "ready to work offline", which is the confirmation a seller wants before
 * walking into a hall with no signal.
 */

import { useRegisterSW } from 'virtual:pwa-register/react';

export default function UpdatePrompt() {
  const {
    offlineReady: [offlineReady, setOfflineReady],
    needRefresh: [needRefresh, setNeedRefresh],
    updateServiceWorker,
  } = useRegisterSW();

  if (!offlineReady && !needRefresh) return null;

  return (
    <div className="toast" role="status">
      {needRefresh ? (
        <>
          <span>A new version is available.</span>
          <button type="button" onClick={() => void updateServiceWorker(true)}>
            Reload
          </button>
          <button type="button" className="ghost" onClick={() => setNeedRefresh(false)}>
            Later
          </button>
        </>
      ) : (
        <>
          <span>Ready to work offline.</span>
          <button type="button" className="ghost" onClick={() => setOfflineReady(false)}>
            Dismiss
          </button>
        </>
      )}
    </div>
  );
}
